<div
  class="tab-bar flex justify-start font-condensed font-medium border-b border-grey-light-1 -mr-3 md:mx-0 mt-0.5"
  aria-label="tabIndex"
  role="tablist"
>
  <div
    *ngFor="
      let tabBarLink of tabBarLinks;
      let isFirst = first;
      let tabIndex = index
    "
    class="tab-bar__item"
    [class.md:ml-8]="!isFirst"
    routerLinkActive="tab-bar__item--active"
  >
    <a
      #tabs
      [id]="getTabId(tabIndex)"
      [routerLink]="tabBarLink.path"
      queryParamsHandling="preserve"
      routerLinkActive
      #rla="routerLinkActive"
      class="tab-bar__item__link"
      (keydown)="onKeydown($event)"
      [attr.aria-selected]="rla.isActive ? true : null"
      [attr.aria-controls]="tabpanelId"
      [attr.aria-label]="tabBarLink?.name"
      role="tab"
      [tabIndex]="rla.isActive ? 0 : -1"
    >
      {{ tabBarLink.name }}
    </a>
  </div>
</div>

<div [id]="tabpanelId" role="tabpanel" [attr.aria-labelledby]="ariaLabelledBy">
  <ng-content></ng-content>
</div>
